// Port of api/fuel/app/classes/filter/package/games/play/package/plays.php
import F from 'offline/filter/constants'
export default {
	run: function(pkg, local, global) {
		var gameId = local.result ? parseInt(local.result.game_id || local.id || 0, 10) : local.game_id
		var userId = local.result ? parseInt(local.result.user_id || global.userID || 0, 10) : global.userID
		var up = global.plays && global.plays.user && global.plays.user.all && global.plays.user.all[userId]
			? global.plays.user.all[userId][gameId]
			: false
		var upCtx = global.plays && global.plays.user && global.plays.user.context && global.plays.user.context[userId]
			? global.plays.user.context[userId][gameId]
			: false
		var gp = global.plays && global.plays.group && global.plays.group.all
			? global.plays.group.all[gameId]
			: false
		var gpCtx = global.plays && global.plays.group && global.plays.group.context
			? global.plays.group.context[gameId]
			: false
		var hasContext = !!(global.filter && global.filter.played && global.filter.played.range && global.filter.played.range.from)
		var playCount = local.result && local.result.play_count ? local.result.play_count : 0

		if (global.ownerType === F.OWNER_USER || !(global.filter && global.filter.play && global.filter.play.group)) {
			pkg.plays = {
				user: {
					all: up ? parseInt(up.count || 0, 10) : 0,
					context: upCtx ? parseInt(upCtx.count || 0, 10) : (up ? parseInt(up.count || 0, 10) : 0),
					duration: {
						all: up ? parseInt(up.minutes || 0, 10) : 0,
						context: upCtx ? parseInt(upCtx.minutes || 0, 10) : (up ? parseInt(up.minutes || 0, 10) : 0)
					}
				}
			}
			if (!(global.filter && global.filter.play && global.filter.play.group)) {
				pkg.plays.user.increment = local.previous && local.previous.user !== undefined ? local.previous.user + playCount : playCount
				pkg.plays.user.contextIncrement = hasContext
					? ((local.previous && local.previous.userContext !== undefined ? local.previous.userContext : 0) + playCount)
					: false
				pkg.plays.user.first = !(local.previous && local.previous.user)
			}
		}
		if (global.ownerType !== F.OWNER_USER) {
			pkg.plays = pkg.plays || {}
			pkg.plays.group = {
				all: gp ? parseInt(gp.count || 0, 10) : 0,
				context: gpCtx ? parseInt(gpCtx.count || 0, 10) : (gp ? parseInt(gp.count || 0, 10) : 0),
				duration: {
					all: gp ? parseInt(gp.minutes || 0, 10) : 0,
					context: gpCtx ? parseInt(gpCtx.minutes || 0, 10) : (gp ? parseInt(gp.minutes || 0, 10) : 0)
				}
			}
			if (!(global.filter && global.filter.play && global.filter.play.group)) {
				pkg.plays.group.increment = local.previous && local.previous.group !== undefined ? local.previous.group + playCount : playCount
				pkg.plays.group.contextIncrement = hasContext
					? ((local.previous && local.previous.groupContext !== undefined ? local.previous.groupContext : 0) + playCount)
					: false
				pkg.plays.group.first = !(local.previous && local.previous.group)
			}
		}
		return pkg
	}
}
